<template>
  <div fluid :style="{'padding-left':'0px', 'padding-right':'0px', 'display': (view_type == ViewType.MAIN_VIEW_TYPE ? 'block' : 'none')}">
    <v-card tile ref="main_container" class="pa-0" :style="{'min-height': `${display.main.height}px`}">
      <div :style="{float: 'left', display: 'flex', alignItems: 'center', visibility: (main_view_zoomed_node_id > 0) ? 'visible' : 'hidden'}" id="mainViewZoomInfo">
        <span>View zoomed on </span>
        <span style="display: flex; height: max-content;">
          <span v-for="(item, index) in zoom_node_parents" :key='index' class="zoomInSpan" :style="{background: color_map[item] || color_map.default, color:is_color_dark[item] ? 'white' : 'black'}">{{item}}</span>
        </span>
      </div>
      <svg  ref="view" :width="display.main.width" :height="display.main.height">
        <g class="content" :transform="`translate(${display.main.padding.left}, ${display.main.padding.top})`"></g>
        <text class="axis-text axis--x-text" text-anchor="end" :transform="`translate(${display.main.padding.left + display.main.innerWidth}, ${display.main.padding.top+ display.main.innerHeight - 5})`">Sum of averages of the treatments (days)</text>
        <g class="axis axis--x" :transform="`translate(${display.main.padding.left}, ${ (display.main.height - display.main.padding.bottom) +1})`"></g>
      </svg>
      <div ref="tooltip"></div>
    </v-card>
  </div>
</template>

<script>

import * as d3 from "d3"
import { mapMutations, mapActions, mapGetters } from "vuex"
import { ViewType } from "../Config"
import * as treeUtils from "@/treeUtils"
import { drawtree }  from "./DrawTree"
import * as tooltip from "./Tooltip"

/** \brief  This component is the MainView displaying the sequences of events per non-filtered individuals */
export default {
  data: () => ({ 
    curtree : null,
    zoom_node_parents: [],
    ViewType: ViewType,
  }),
  watch: {
    tree(data) {
      if(this.main_view_zoomed_node_id >= 0)
        this.updateCurtree();
      this.draw(data)
    },
    
    display_flag() {
      if (this.tree) this.draw(this.tree)
    },
   
    view_type() {
      this.draw(this.tree)
    },
    main_view_zoomed_node_id() {
      this.curtree = null;

      d3.select(this.$refs.view).on("dblclick", (_e, _d) => {
        if(this.main_view_zoomed_node_id == -1)
          return;
        this.set_main_view_zoomed_node_id({id: -1});
        this.draw(this.tree);
      });

      this.updateCurtree();
      this.draw(this.tree);
    },
  },
  computed: {
    ...mapGetters(['view_type', 'tree', 'color_map', 'display', 'display_flag', 'main_view_zoomed_node_id', 'is_color_dark']),
  },
  mounted() {
    const tooltipDiv = d3.select(this.$refs.tooltip);
    tooltip.reinit(tooltipDiv);

    this.updateCurtree();
    this.draw(this.tree);
  },
  methods: {
    ...mapActions(['get_distribution', 'set_main_view_zoomed_node_id']),
    ...mapMutations(['set_tab', 'set_current_sequence']),

    /** \brief  Update the rendering of what node the user has zoomed in */
    updateCurtree() {
      this.curtree = treeUtils.searchNodeByID(this.tree, this.main_view_zoomed_node_id);
      if(this.curtree == null)
        this.zoom_node_parents = [];
      else {
        this.zoom_node_parents = this.computePrefix(this.tree, this.curtree);
      }
    },

    /** \brief  Draw the tree of the sequences
    * \param treedata the data to render */
    draw(treedata) {
      if(this.view_type != ViewType.MAIN_VIEW_TYPE)
        return;
      drawtree(this, this.$refs, treedata, (this.curtree == null ? treedata : this.curtree), this.display.main.innerWidth, true, "view", this.zoomIn, "patients");
    },
  
    /** \brief  Called by "drawtree" when the user wants to zoomIn a node
    * \param tree the node to which the user wants to zoom in */
    zoomIn(tree) {
      this.set_main_view_zoomed_node_id({id: tree.id});
    },

    /** \brief  Compute the prefix (i.e., the whole sequence that leads to this node) of a node starting from curtree (as given by, e.g., drawtree)
    * \param curtree the root of the tree
    * \param node the node to compute the prefix from. The algorithm stops at curtree
    * \return an array containing the whole sequence leading to node, node included.*/
    computePrefix(curtree, node) {
      let parents = [...treeUtils.getParents(curtree, node), node];
      let prefix = new Array();

      for(let i = parents.length-1; i > 0; i--) //avoid curtree
        prefix = [parents[i].name].concat(prefix);
      return prefix;
    },

    /** \brief  Function called when the user clicks on a node. This updates the "rendered prefix" to let the user know on what "sequence" he/she has clicked on
    * \param curtree the root of the tree
    * \param node the node selected */
    updatenodeprefix(curtree, node) {
      this.set_current_sequence(this.computePrefix(curtree, node));
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
rect:hover {
  fill-opacity: 0.75;
  cursor: pointer;
}
.axis-text{
  font-size: 0.7em;
}
.selectedNode{
  stroke: black;
  stroke-width: 2px;
}
.zoomInSpan{
  float: right;
  width: max-content;
  height: max-content;
}
</style>
